"use client";

import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  if (!mounted) {
    return (
      <div className="flex h-8 w-[5.25rem] items-center justify-center rounded-full" />
    );
  }

  const isDark = resolvedTheme === "dark";

  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className="text-[0.8rem] italic tracking-[0.12em] text-muted transition-colors duration-300 hover:text-foreground font-serif"
      aria-label="Toggle color theme"
    >
      {isDark ? "light" : "dark"}
    </button>
  );
}
